import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

const benefits = [
  "Commitment-backed groups show up — deposits lock attendance",
  "Pre-committed groups tend to spend more per visit",
  "Zero split-bill chaos — we settle everything automatically",
  "CRM data on preferences, history & group dynamics",
  "Simple, transparent commission — no hidden fees",
  "Guaranteed footfall with deposit-backed bookings",
];

const VenueSection = () => {
  return (
    <section id="venues" className="section-padding bg-card">
      <div className="mx-auto max-w-7xl">
        <div className="grid items-center gap-16 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="mb-4 inline-block text-sm font-semibold uppercase tracking-widest text-secondary">
              For Venues
            </span>
            <h2 className="mb-6 text-4xl font-bold md:text-5xl">
              We don't compete with you.{" "}
              <span className="text-gradient-gold">We send you better customers.</span>
            </h2>
            <p className="mb-8 text-lg text-muted-foreground font-body leading-relaxed">
              Zero listing fees. No margin cuts on bottles. Just pre-committed groups 
              who actually show up, spend more, and never argue about the bill.
            </p>
            <Link
              to="/auth?redirect=/vendor&role=vendor"
              className="inline-flex items-center gap-2 rounded-xl bg-secondary px-8 py-4 text-base font-semibold text-secondary-foreground transition-all hover:opacity-90 glow-gold"
            >
              Partner With Us
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            {benefits.map((benefit, i) => (
              <motion.div
                key={benefit}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="flex items-start gap-4 rounded-xl border border-border bg-background p-5"
              >
                <CheckCircle2 className="mt-0.5 h-5 w-5 flex-shrink-0 text-secondary" />
                <span className="text-sm font-medium text-foreground font-body">{benefit}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VenueSection;
